import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: [],
};

export const offerSlice = createSlice({
  name: "offer",
  initialState,
  reducers: {
    crOffer: (state, action) => {
      state.value.push(action.payload);
    },
  },
});

export const { crOffer } = offerSlice.actions;

export default offerSlice.reducer;
